
let inspection = [
  {
    path: '/inspection',
    name: '检验检查预约',
    component: () => import('@/pages/inspection/inspection')
  },
  {
    path: '/inspection_tag_list',
    name: '检验检查预约',
    component: () => import('@/pages/inspection/inspection_tag_list')
  },
  {
    path: '/inspection_hospital_detail',
    name: '检验检查预约',
    component: () => import('@/pages/inspection/inspection_hospital_detail')
  }
]

export default inspection
